import axios from "axios";
import store from "../index";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
const state = {
    tags:[],
    tag : [],
    index:'',
    sortBy:'',
    sortDesc:''



};

const getters = {
    getTags: state => {
        return state.tags;
    },
    getTag: state => {
        return state.tag;
    },
    getIndex: state => {
        return state.index;
    },
    getSortBy: state => {
        return state.sortBy;
    },
    getSortDesc: state => {
        return state.sortDesc;
    },



};

const actions = {

    asyncFetchData : async (context,settings) => {

        const {sortBy, sortDesc, page, itemsPerPage} = settings.options;
        let url = "tags";

        context.commit('setSortDesc', sortDesc[0]);
        context.commit('setSortBy', sortBy[0]);
        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "sortBy": context.rootGetters['tags/getSortBy'],
                    'sortDesc': context.rootGetters['tags/getSortDesc'],
                    'page': page,
                    'itemsPerPage': itemsPerPage,
                    'filters': (settings.filters)?settings.filters:'',
                    'search': settings.search
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                //console.log(res.data.pagination);
                context.commit('setTags', res.data.data);
                return res.data.pagination
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },
    fetchLists : async (context,payload) => {

        let url = "tags/lists";

        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                //console.log(res.data.pagination);

                return res.data
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },
    searchTag : async (context,payload) => {
        let url = "tags/search";
        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}/${payload.search}`,
          {
              'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
              "Content-Type": "application/json"
          },
        ).then(res => {
              return res.data.data
        }).catch(err => {
              console.log("errore", err);
        });
    },

    deleteTags : async (context,settings) => {


        let url = "tags/delete";


        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "query": settings
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            }
        )

            .then(res => {
                //console.log(res.data.pagination);
                //context.commit('setCategories', res.data.data);
                return res.data
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err.response.status);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
                return {error:err.response.status}
                //throw Error(err.response.status);
            });

    },


    getDetailTag : async (context,payload) =>{
        //console.log(payload)
        let url = `tags/detail/${payload}`;


        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);
                //context.commit('setCategoriesTree', res.data.data);
                return {data:res.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
              /*  if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });
    },
    destroyData : (context) =>{
        context.commit('setTags',[]);
        context.commit('setTag',[]);



    },


};

const mutations = {
    setTags: (state,value) => {
        state.tags= value;
    },
    setTag: (state,value) => {
        state.tag= value;
    },
    setSortBy: (state,value) => {
        state.sortBy= value;
    },
    setIndex: (state,value) => {
        state.index= value;
    },
    setSortDesc: (state,value) => {
        state.sortDesc= value;
    }



};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
